import { directus, nodeAPI } from "../Config/ApiUrls";
import { Api } from "../Config/Requests";
import { storage } from "../Config/Storage";
const phone = storage.fetch.phone()

export const requestimguploaded = async (data, file_id) => {
    return file_id === undefined ? Api.PostRequest(directus + `files`, data) : Api.PatchRequest(directus + `files/${file_id}`, data)
};
export const requestuserupdate = async (data, user_id) => {
    return Api.PatchRequest(directus + `users/${user_id}`, data);
};

export const requestuser = async (data) => {
    return Api.GetRequest(directus + `users/${data}`)
}

export const requestchoosetype = async (data) => {
    return await Api.PatchRequest(directus + `users/${phone}`, { userrole: data.role });
};


// Define All User APIs
const UserApiRequests = {
    requestimguploaded,
    requestuserupdate,
    requestuser,
    requestchoosetype
};
export default UserApiRequests;